import type { FetchApi } from '../client';

export type ApiPricingResponse = {
  pricingPlan: string;
  billingStatus: string;
  billingEmail: string;
  freeTrial: boolean;
  freeTrialStart: Date | null;
  freeTrialEnd: Date | null;
};

const pricingDefaultValues: ApiPricingResponse = {
  pricingPlan: 'freemium',
  billingStatus: 'current',
  billingEmail: '',
  freeTrial: false,
  freeTrialStart: null,
  freeTrialEnd: null,
};

export const flagApi = (fetchApi: FetchApi) => ({
  getAllFlags(
    token: string,
  ): Promise<Record<string, boolean | string | number>> {
    return (
      fetchApi
        .setToken(token)
        // adding timestamp to avoid caching issues with feature flags
        .get(`/app/getAllFlags?t=${new Date().getTime()}`)
        .then((response) => {
          return response || {};
        })
        .catch((errorMessage) => {
          console.error(
            (typeof errorMessage === 'string' && errorMessage) ||
              'Unable to get feature flag values.',
          );
          return {};
        })
    );
  },
  getPricingPlanCheck(token: string): Promise<ApiPricingResponse> {
    return fetchApi
      .setToken(token)
      .get('/app/pricingPlanCheck')
      .then((response: ApiPricingResponse) => {
        return response;
      })
      .catch((errorMessage) => {
        console.error(
          (typeof errorMessage === 'string' && errorMessage) ||
            'Unable to check feature pricing plan.',
        );
        return pricingDefaultValues;
      });
  },
});
